import { render } from "./MenuManage.vue?vue&type=template&id=2dd8d579&scoped=true"
import script from "./MenuManage.vue?vue&type=script&lang=js"
export * from "./MenuManage.vue?vue&type=script&lang=js"

import "./MenuManage.vue?vue&type=style&index=0&id=2dd8d579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd8d579"]])

export default __exports__